import { Font } from "components/shopFeatures/wizard/constants"
import { useAppDispatch, useTypedSelector } from "store"
import styled from "styled-components"
import { backToPhoneStep, generateVerificationCode } from "../authSlice"

const StyledContainer = styled.div`
  margin-top: ${(p) => p.theme.spacing(2)}px;
`
const StyledButtonContainer = styled.div`
  margin-top: 20px;
  color: ${(p) => p.theme.colors.black};
`

const StyledLink = styled.a<{ $disabled?: boolean }>`
  font-family: ${Font.OENaPro};
  font-size: 16px;
  font-weight: 300;
  line-height: 22px;
  letter-spacing: 0em;
  cursor: pointer;
  text-decoration: underline;

  ${(p) =>
    p.$disabled &&
    `
    color: ${p.theme.colors.darkGrey};
  `}

  :hover {
    color: ${(p) => p.theme.colors.cherryRed};
  }
`

const StyledOtherNumberLink = styled(StyledLink)`
  color: ${(p) => p.theme.colors.saphire};
`

type ChangeNumberAndSendAgainButtonsProps = {
  focusCodeInput: () => void
}

const ChangeNumberAndSendAgainButtons = ({
  focusCodeInput,
}: ChangeNumberAndSendAgainButtonsProps) => {
  const { loading, allowSendingCodeAgain } = useTypedSelector(
    (state) => state.auth
  )

  const dispatch = useAppDispatch()

  return (
    <StyledContainer>
      <StyledButtonContainer>
        לא הגיע אלי,{" "}
        <StyledLink
          onClick={async () => {
            if (!allowSendingCodeAgain) return
            await dispatch(generateVerificationCode(undefined))

            focusCodeInput()
          }}
          aria-pressed={loading || !allowSendingCodeAgain}
          $disabled={loading || !allowSendingCodeAgain}
        >
          שלחו שוב
        </StyledLink>
      </StyledButtonContainer>

      <StyledButtonContainer>
        <StyledOtherNumberLink
          onClick={() => dispatch(backToPhoneStep())}
          $disabled={loading}
        >
          אני רוצה להתחבר עם נייד אחר
        </StyledOtherNumberLink>
      </StyledButtonContainer>
    </StyledContainer>
  )
}

export default ChangeNumberAndSendAgainButtons
